import React from 'react'
import { Route } from 'react-router'
import Layout from './layout'
import { routes as SchoolRoutes } from './schools'
import { routes as SearchRoutes } from './search'
import { routes as PartnerRoutes } from './partners'
import { routes as TeachingArtistRoutes } from './teaching-artist'
import { getCurrentCommunity, isTeachingArtistEnabled } from 'utils'

const community = getCurrentCommunity()

const Routes = (
  <Route component={Layout}>
    {SearchRoutes}
    {SchoolRoutes}
    {PartnerRoutes}
    {isTeachingArtistEnabled(community) && TeachingArtistRoutes}
  </Route>
)

export default Routes
